import React from 'react';
import { SingleMessage } from './SingleMessage';

export interface ChatMessage {
  smsId: number;
  user: {
    firstName: string;
    lastName: string;
  };
  chatId: number;
  type: string;
  text: string;
  createdAt: string;
  deliveredAt?: string;
  images: Array<{
    fileName: string;
  }>;
}

interface MessageListProps {
  chatMessages: ChatMessage[];
  selectedName: string;
}

export const MessageList: React.FC<MessageListProps> = ({
  chatMessages,
  selectedName,
}) => {
  return (
    <>
      {chatMessages.map(chat => (
        <SingleMessage
          key={chat.chatId}
          chat={chat}
          selectedName={selectedName}
        />
      ))}
    </>
  );
};
